import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { X, SwitchCamera } from "lucide-react";

export default function QRScanModal({ onClose, onDecode }) {
  const scannerRef = useRef(null);
  const handledRef = useRef(false);
  const [facing, setFacing] = useState("environment");
  const [err, setErr] = useState("");

  const startWith = async (f) => {
    try {
      const s = new Html5Qrcode("friend-reader");
      scannerRef.current = s;
      await s.start({ facingMode: f }, { fps: 10, qrbox: { width: 220, height: 220 }, aspectRatio: 1.0 }, (text) => {
        if (handledRef.current) return;
        handledRef.current = true;
        onDecode(text);
      }, () => {});
    } catch (e) { setErr("Could not start camera. Try 'Add by code' instead."); }
  };

  const stop = async () => {
    const s = scannerRef.current;
    if (s) { try { await s.stop(); await s.clear(); } catch (e) { console.error("scanner stop failed", e); } scannerRef.current = null; }
  };

  useEffect(() => {
    startWith("environment");
    return () => { stop(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const switchCam = async () => {
    const next = facing === "environment" ? "user" : "environment";
    setFacing(next);
    await stop();
    handledRef.current = false;
    startWith(next);
  };

  const close = async () => { await stop(); onClose(); };

  return (
    <div className="fixed inset-0 z-[60] bg-black/85 backdrop-blur-sm flex items-center justify-center p-6" data-testid="qr-scan-modal">
      <div className="w-full max-w-sm rounded-3xl bg-[#1a1424] border border-white/10 p-5">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-display text-lg font-semibold">Scan friend QR</h3>
          <button onClick={close} data-testid="qr-scan-close" className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center active:scale-90 transition-transform"><X size={18} /></button>
        </div>
        <div className="relative rounded-2xl overflow-hidden bg-black mx-auto w-full max-w-[280px] aspect-square">
          <div id="friend-reader" className="w-full h-full" />
        </div>
        {err
          ? <p className="text-[#ff8a8a] text-sm mt-3 text-center">{err}</p>
          : <p className="text-[#A19DB0] text-xs mt-3 text-center">Point the camera at a friend's QR code.</p>}
        <button onClick={switchCam} data-testid="qr-scan-switch" className="mt-4 w-full rounded-full bg-white/10 border border-white/10 py-2.5 text-sm flex items-center justify-center gap-2 active:scale-95 transition-transform"><SwitchCamera size={15} /> Switch camera</button>
      </div>
    </div>
  );
}
